import React, { useEffect } from 'react';

// Styled like the public site (frontend/public/site), not the old React theme.
// Links are plain anchors so they leave the React app and load the site itself.
const C = { black: '#080808', line: '#262626', ink: '#F3F1EC', ink2: '#A6A6A6', ink3: '#6E6E6E', red: '#E3122C' };
const font = "'Archivo', 'Helvetica Neue', Arial, sans-serif";
const links: [string, string][] = [['/#home', 'Find a racer'], ['/#results', 'Events'], ['/#stats', 'Stats'], ['/#season', 'The 2026 season'], ['/site/game/', 'Play']];

export const NotFoundPage: React.FC = () => {
  useEffect(() => {
    const bg = document.body.style.background;
    document.body.style.background = C.black;
    document.title = 'Page not found | RaceCarly';
    return () => { document.body.style.background = bg; };
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: C.black, color: C.ink, fontFamily: font }}>
      <header style={{ borderBottom: `1px solid ${C.line}` }}>
        <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 clamp(16px, 4vw, 56px)', height: 64, display: 'flex', alignItems: 'center' }}>
          <a href="/" aria-label="RaceCarly home"><img src="/site/assets/racecarly-logo.png" alt="RaceCarly" style={{ height: 34, display: 'block' }} /></a>
        </div>
      </header>
      <main style={{ maxWidth: 1320, margin: '0 auto', padding: 'clamp(56px, 9vw, 120px) clamp(16px, 4vw, 56px)' }}>
        <div style={{ fontWeight: 700, fontSize: 13, color: C.ink3, fontStretch: '112%' }}>404</div>
        <h1 style={{ margin: '10px 0 0', fontStretch: '125%', fontWeight: 900, fontSize: 'clamp(42px, 7vw, 108px)', letterSpacing: '-0.03em', lineHeight: 0.9 }}>Wrong turn</h1>
        <p style={{ fontSize: 'clamp(17px, 1.5vw, 20px)', color: C.ink2, maxWidth: '36em', lineHeight: 1.5, margin: '22px 0 32px' }}>
          There is nothing at this address. The results, racers and events all live on the home page.
        </p>
        <a href="/" style={{ display: 'inline-block', fontWeight: 800, fontSize: 18, fontStretch: '112%', color: C.ink, background: C.red, borderRadius: 4, padding: '16px 24px', textDecoration: 'none' }}>Back to RaceCarly</a>
        <nav aria-label="Elsewhere" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 10px', marginTop: 32 }}>
          {links.map(([href, label]) => (
            <a key={href} href={href} style={{ textDecoration: 'none', fontWeight: 700, fontSize: 14, color: C.ink2, border: `1px solid ${C.line}`, borderRadius: 999, padding: '6px 13px' }}>{label}</a>
          ))}
        </nav>
      </main>
      <footer style={{ borderTop: `1px solid ${C.line}`, color: C.ink3, fontSize: 14 }}>
        <div style={{ maxWidth: 1320, margin: '0 auto', padding: '32px clamp(16px, 4vw, 56px)' }}>For entertainment purposes only. Data was sourced from public results.</div>
      </footer>
    </div>
  );
};
